import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ViewMasterModalService {

  private selectedViewMasterSubject = new BehaviorSubject<any>(null);
  public selectedViewMaster$ = this.selectedViewMasterSubject.asObservable();

  constructor() { }

  setSelectedViewMaster(viewMaster: any): void {
    this.selectedViewMasterSubject.next(viewMaster);
  }

  getSelectedViewMaster(): any | null {
    return this.selectedViewMasterSubject.value;
  }

  clearSelectedViewMaster(): void {
    this.selectedViewMasterSubject.next(null);
  }
}
